
import '@accessible360/accessible-slick';

function init() {
  // The import * as tns syntax was being rewritten by Vite to window['tns'] at module parse time,
  // before the pageScripts bundle that defines window.tns had run.
  const tns = window['tns'];
  if (tns) {
    InitIconSlider(tns);
    InitHeroProductSlider(tns);
    InitProductDetailSlider(tns);
    InitProductSpecSlider(tns);
  } else {
    console.warn('tns not loaded — skipping tns-dependent sliders');
  }
  InitBoughtTogether();
  InitAwardsSlider();
  InitFoundationSlider();
  InitPerformanceHighlightHeroSlider();

}
function InitIconSlider(tns) {
    if (document.querySelector('.icon-slider')) {
      let iconSlider;
  
  
  
      iconSlider = tns({
        container: ".icon-slider",
        items: 1,
        lazyload: true,
        mode: 'gallery',
  
        controlsContainer: "#icon-slider-nav",
        mouseDrag: true,
        autoplayHoverPause: false,
  
  
        slideBy: 1,
  
        responsive: {
          641: {
            disable: true,
          }
        },   /**/
      })
  
    }
  }
  
  const onInit = function (info) {
    info.controlsContainer.setAttribute('tabindex', -1);
    // info.nextButton.setAttribute('tabindex', 0);
    // info.prevButton.setAttribute('tabindex', 0);
  }
  
  function InitHeroProductSlider(tns) {
    if (document.querySelector('.hero__product-slider')) {
      let slider = tns({
        container: ".hero__product-slider",
        items: 1,
        lazyload: true,
        onInit: onInit,
        controlsContainer: "#customize-controls",
        responsive: {
          640: {
            edgePadding: 20,
            gutter: 20,
            items: 2,
          },
          900: {
            items: 3,
          },
          1024: {
            items: 2,
          },
          1250: {
            items: 3,
          },
          1500: {
            items: 4,
          },
        },
      });
    }
  }
  
  // Set all elements in a jQuery collection to the tallest natural height among them.
  function equalizeHeight(elements, also) {
    if (!elements || elements.length === 0) return 0;
    elements.css("height", "");
    let maxHeight = 0;
    elements.each(function () { maxHeight = Math.max(maxHeight, $(this).height()); });
    elements.height(maxHeight);
    if (also) also.height(maxHeight);
    return maxHeight;
  }

  // Wire up a debounced resize listener and an image-load listener that both
  // call resizeFunc. imgs is a jQuery collection of <img> elements to watch.
  function bindResizeAndImageLoad(imgs, resizeFunc) {
    const debounce = 10;
    let resizeInterval = setTimeout(resizeFunc, debounce);

    // Run after all images have loaded (handles cached images too)
    if (imgs.length > 0) {
      let imgsLoaded = 0;
      imgs.on('load', function () {
        if (++imgsLoaded >= imgs.length) {
          clearTimeout(resizeInterval);
          resizeFunc();
        }
      });
      imgs.each(function () { if (this.complete) $(this).trigger('load'); });
    }

    addEventListener("resize", function () {
      clearTimeout(resizeInterval);
      resizeInterval = setTimeout(resizeFunc, debounce);
    });
  }

  function InitProductDetailSlider(tns) {
    if (!document.querySelector('.product-detail-slider')) return;

    const sliderEl = $('.product-detail-slider');
    const thumbsEl = $('.product-detail-thumbnails');

    const mainSlider = tns({
      container: ".product-detail-slider",
      items: 1,
      lazyload: true,
      controlsContainer: "#customize-controls-product",
      navContainer: '.product-detail-thumbnails',
      slideBy: 'page',
      edgePadding: 0,
      gutter: 0,
      loop: false,
      mouseDrag: true,
      autoplayHoverPause: false,
    });

    const thumbSlider = tns({
      container: ".product-detail-thumbnails",
      items: 5,
      lazyload: true,
      controlsContainer: "#customize-controls-product",
      loop: false,
      slideBy: 1,
      edgePadding: 10,
      gutter: 10,
    });

    const overflowCount = thumbsEl.children().length - 4;
    const hasOverflow   = thumbsEl.children().length > 5;

    if (hasOverflow) {
      thumbsEl.parents('.tns-outer').append(`<div class="additional-number">+${overflowCount}</div>`);
    }

    mainSlider.events.on('indexChanged', function (evt) {
      if (!hasOverflow || document.body.clientWidth <= 1024) return;
      if (overflowCount - evt.index > 0) {
        $('.additional-number').fadeIn(250).text(`+${overflowCount - evt.index}`);
      } else {
        $('.additional-number').hide();
      }
      thumbSlider.goTo(evt.index - 1);
    });

    function resizeFunc() {
      equalizeHeight(sliderEl.find('.slider-img-container'));
      equalizeHeight(sliderEl.find('.caption'));
      equalizeHeight(thumbsEl.find('.product-thumb-container'));
    }

    bindResizeAndImageLoad(sliderEl.find('img'), resizeFunc);
  }

  // -------------------------------------------------------------------------------------------------------
  function InitProductSpecSlider(tns) {
    if (!document.querySelector('.product-spec-slider')) return;

    try {
      $(".product-spec-slider").each(function () {
        const slider = $(this);

        const sliderId  = slider.attr("id");
        if (!sliderId) return;

        const thumbsSel    = "#" + slider.attr("s-thumbs-id");
        const controlsSel  = "#" + slider.attr("s-controls-id");
        const overflowSel  = "#additional-" + sliderId;

        const sliderContainer = slider[0];
        const thumbsContainer = $(thumbsSel)[0];

        // Check if slider has child elements (slides)
        if (!sliderContainer || sliderContainer.children.length === 0) {
          console.warn(`No slides found in slider: #${sliderId}`);
          slider.removeClass('tns-loading');
          return;
        }

        // Check if thumbnails container exists and has children
        if (!thumbsContainer || thumbsContainer.children.length === 0) {
          console.warn(`No thumbnails found in: ${thumbsSel}`);
          slider.removeClass('tns-loading');
          return;
        }

        const controlsEl       = $(controlsSel);
        const hasControls      = controlsEl.length > 0;
        const controlsContainer = hasControls ? controlsEl[0] : null;

        const mainSlider = tns({
          container: sliderContainer,
          items: 1,
          lazyload: true,
          controlsContainer: controlsContainer,
          navContainer: thumbsContainer,
          slideBy: 'page',
          edgePadding: 0,
          gutter: 0,
          loop: false,
          mouseDrag: true,
          autoplayHoverPause: false,
          navAsThumbnails: true,
          controls: hasControls,
          onInit: function() {
            // Remove loading class when carousel is ready
            slider.removeClass('tns-loading');
          }
        });

        const thumbSlider = tns({
          container: thumbsContainer,
          items: 5,
          lazyload: true,
          controlsContainer: controlsContainer,
          loop: false,
          slideBy: 1,
          edgePadding: 10,
          gutter: 10,
          controls: hasControls
        });

        const thumbsEl      = $(thumbsSel);
        const thumbCount    = thumbsEl.children().length;
        const overflowCount = thumbCount - 4;
        const hasOverflow   = thumbCount > 5;

        if (hasOverflow) {
          thumbsEl.parents('.tns-outer').append(`<div id="additional-${sliderId}" class="additional-number2">+${overflowCount}</div>`);
        }

        mainSlider.events.on('indexChanged', function (evt) {
          if (!hasOverflow || document.body.clientWidth <= 1024) return;
          if (overflowCount - evt.index > 0) {
            $(overflowSel).fadeIn(250).text(`+${overflowCount - evt.index}`);
          } else {
            $(overflowSel).hide();
          }
          thumbSlider.goTo(evt.index - 1);
        });

        function resizeFunc() {
          if (hasOverflow) {
            document.body.clientWidth > 1024 ? $(overflowSel).fadeIn(250) : $(overflowSel).hide();
          }
          equalizeHeight(slider.find(".slider-img-container"));
          equalizeHeight(slider.find(".caption"));
          equalizeHeight(thumbsEl.find(".product-thumb-container"), hasOverflow ? $(overflowSel) : null);
        }

        bindResizeAndImageLoad(slider.find('img'), resizeFunc);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  function InitBoughtTogether() {
    if (document.querySelector('.frequently-bought-together')) {
      if ($('.frequently-bought-slider').children().length > 0) {
        $('.frequently-bought-slider').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          arrows: true,
          nextArrow: '.frequently-bought-together .next',
          prevArrow: '.frequently-bought-together .prev',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerPadding: '20px',
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                centerPadding: '10px',
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
  
        $('.frequently-bought-together .next').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.frequently-bought-slider').slick('slickNext');
          }
        })
        $('.frequently-bought-together .prev').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.frequently-bought-slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.frequently-bought-together').remove();
      }
    }
  }
  
  function InitAwardsSlider() {
    if (document.querySelector('.awards-slider')) {
      if ($('.awards-slider .slides').children().length > 0) {
        $('.awards-slider .slides').on('init', function (e, slick) {
          $(this).parent().parent().find('.page').text('1 / ' + $('.awards-slider .slide').length);
        });
        $('.awards-slider .slides').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: true,
          nextArrow: '.awards-slider .forward',
          prevArrow: '.awards-slider .back',
        });
        $('.awards-slider .slides').on('afterChange', function (slick, currentSlide) {
          $(this).parent().parent().find('.page').text(currentSlide.currentSlide + 1 + ' / ' + $('.awards-slider .slide').length);
        });
        $('.awards-slider .forward').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.awards-slider .slider').slick('slickNext');
          }
        })
        $('.awards-slider .back').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.awards-slider .slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.awards-slider').remove();
      }
    }
  }
  
  function InitPerformanceHighlightHeroSlider() {
    if (document.querySelector('.performance-highlight-hero')) {
      if ($('.performance-highlight-hero .items').children().length > 0) {
        $('.performance-highlight-hero .items').slick({
          dots: true,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: false,
        });
      }
      else {
        $('.performance-highlight-hero .items').remove();
      }
    }
  }
  
  function InitFoundationSlider() {
    if (document.querySelector('.foundation-slider')) {
      if ($('.foundation-slider .slides').children().length > 0) {
        $('.foundation-slider .slides').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: true,
          nextArrow: '.foundation-slider .forward',
          prevArrow: '.foundation-slider .back',
        });
        $('.foundation-slider .forward').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.foundation-slider .slider').slick('slickNext');
          }
        })
        $('.foundation-slider .back').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.foundation-slider .slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.foundation-slider').remove();
      }
    }
  }
  
export {
    init
}